/* unplugin-vue-components disabled */import script from "./PagePopupLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePopupLayout.vue?vue&type=script&setup=true&lang=js"

import "./PagePopupLayout.vue?vue&type=style&index=0&id=1a81e1b5&lang=scss"

const __exports__ = script;

export default __exports__